// CUSTOM: Firework Product Hydration

// Function to fetch product details from Shopify using product handle
async function fetchProductsFromServer(products) {
    const storeUrl = window.location.pathname?.includes('en-ca') ? `${window.location.origin}/en-ca` : window.location.origin;

    const fetchedProducts = await Promise.all(
        products.map(async (product) => {
            const productHandle = product.product_handle;

            if (!productHandle) {
                console.warn("Missing product handle for product:", product);
                return null;
            }
            
            try {
                const url = `${storeUrl}/products/${productHandle}?view=discount-eligible`;
                const response = await fetch(url);

                if (!response.ok) {
                throw new Error(`Failed to fetch product details for ${productHandle}, Status: ${response.status}`);
                }

                const responseText = await response.text();

                if (responseText) {
                return JSON.parse(responseText);
                }
                else {
                console.error(`No product data found for ${productHandle}`);
                return null;
                }
            }
            catch (error) {
                console.error("Error fetching product details:", error);
                return null;
            }
        })
    );

    return fetchedProducts;
}

// Helper method to convert a remote product to a Firework product object.
function buildFWProduct(remoteProduct) {
    const { id, variants, currency } = remoteProduct;

    // Use `shopping.productFactory` to build Firework product object
    return window._fwn.shopping.productFactory((product) => {
        // 1. Update the product
        product
        .extId(id)
        .currency(currency)

        // 2. Update product variant 
        for (const remoteVariant of variants) {
            const { 
                id: variantId,
                price,
                discount
            } = remoteVariant;
            
            product.variant((variant) => {
                variant
                .extId(variantId)
                .price(Math.ceil(price * discount) / 100)
                .originalPrice(Math.ceil(price) / 100)
            });
        }
    });
}

window.addEventListener("load", () => window._fwn.shopping.onProductsLoaded(async ({ products }) => {        
    // Make a server request to get the latest product data.
    const remoteProducts = await fetchProductsFromServer(products);

    return remoteProducts.filter((remoteProduct) => remoteProduct != null).map((remoteProduct) => buildFWProduct(remoteProduct));
}));

// - - - - - - - - - - 

async function addToShopifyCart(variant, quantity) {
    const cartUrl = "/cart/add.js";

    // Construct the payload to add the product
    const data = {
        items: [
            {
                id: variant.unit_ext_id, // Use only the unit_ext_id (variant ID)
                quantity: quantity, // Quantity of the product to add,
                properties: {
                "_firework": "true"
                }
            }
        ]
    };

    try {
        const response = await fetch(cartUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
                body: JSON.stringify(data)
        });

        if (response.ok) {
            const cart = await response.json();
            console.log("Product added to cart:", cart);

            // Find the updated quantity of the added item
            const updatedItem = cart.items.find((item) => item.id == variant.unit_ext_id);
            return updatedItem ? updatedItem.quantity : quantity; // Return updated quantity
        }
        else {
            console.error("Error adding product to cart:", response.status);
            return quantity; // Return original quantity in case of error
        }
    }
    catch (error) {
        console.error("Error making AJAX request to add product to cart:", error);
        return quantity; // Return original quantity in case of failure
    }
}

window.addEventListener("load", () => window._fwn.shopping.onCartUpdated(async ({ product, productUnit, quantity }) => {
    console.log("firework onCartUpdated");

    // Add item to Shopify cart and get the updated quantity
    const updatedQuantity = await addToShopifyCart(productUnit, quantity);

    return updatedQuantity;
}));
